import { makeStyles } from '@material-ui/core';
import React from 'react';
import { PropTypes } from 'prop-types';
const styles = makeStyles({
    radio: {
        position: 'relative',
        display: 'block',
        marginBottom: '16px',
        '& label': {
            direction: 'ltr',
            display: 'block',
            paddingRight: '40px',
            background: '#fff',
            color: 'black',
            borderRadius: '5px',
            padding: '10px 20px',
            marginBottom: '5px',
            cursor: 'pointer',
            '&:after, &:before': {
                content: '""',
                position: 'absolute',
                right: '11px',
                top: '12px',
                width: '20px',
                height: '20px',
                borderRadius: '3px'
            },
            '&:before': {
                transition:
                    '0.1s width cubic-bezier(0.075, 0.82, 0.165, 1) 0s 0.3s height cubic-bezier(0.075, 0.82, 0.165, 2) 0.1s',
                zIndex: '2',
                overflow: 'hidden',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '13px',
                backgroundPosition: 'center',
                width: '0',
                height: '0',
                backgroundImage:
                    'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNS4zIDEzLjIiPiAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE0LjcuOGwtLjQtLjRhMS43IDEuNyAwIDAgMC0yLjMuMUw1LjIgOC4yIDMgNi40YTEuNyAxLjcgMCAwIDAtMi4zLjFMLjQgN2ExLjcgMS43IDAgMCAwIC4xIDIuM2wzLjggMy41YTEuNyAxLjcgMCAwIDAgMi40LS4xTDE1IDMuMWExLjcgMS43IDAgMCAwLS4yLTIuM3oiIGRhdGEtbmFtZT0iUGZhZCA0Ii8+PC9zdmc+)'
            }
        },
        '& input[type=radio]': {
            display: 'none',
            position: 'absolute',
            width: '100%',
            appearance: 'none',
            '&:checked + label': {
                background: '#416ce1',
                color: '#fff',
                '&:after': {
                    background: 'transparent'
                },
                '&:before': {
                    width: '20px',
                    height: '20px'
                }
            }
        }
    }
});

const CustomRadio = ({ value, name, label, id, handleChange }) => {
    const classes = styles();

    return (
        <>
            <div className={classes.radio}>
                <input
                    onChange={handleChange}
                    checked={value === name}
                    id={id}
                    type="radio"
                    value={value}
                    name={name}
                    data-testid={name}
                />
                <label htmlFor={id}>{label} </label>
            </div>
        </>
    );
};
CustomRadio.propTypes = {
    value: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    id: PropTypes.number,
    handleChange: PropTypes.func
};

export default CustomRadio;
